import React from 'react'
import PropTypes from 'prop-types'
import { useWillConstrain } from '@morningtrain/react-filters'
import {useCookies} from "react-cookie";

export default function CookieFilter (props) {
  const [value] = useCookies([props.cookieKey])

  useWillConstrain(props.name, value[props.cookieKey])

  return null
}

CookieFilter.propTypes = {
  name: PropTypes.string.isRequired,
  cookieKey: PropTypes.string.isRequired
}
